import React from 'react';
import {Button, Table} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import partial from 'lodash/partial';
import FieldStatusIcon from 'components/forms/FieldStatusIcon';
import {formatLocalDateTime} from 'utils/DBUtils';

const purchasedTimestamp = ({purchased: {date, time}}) => new Date(
  date.year,
  date.month,
  date.day,
  time.hour,
  time.minute,
  time.second
).valueOf();

// sorts by purchase date chronologically, with most recent items at the top.
const byPurchasedDate = (left, right) => purchasedTimestamp(right) - purchasedTimestamp(left);

class PurchaseInfoContent extends React.Component {
  constructor(props, children) {
    super(props, children);
  }



  render(){
    return(
      <Table.Body>
      {
        this.props.storeOrders.object.slice().sort(byPurchasedDate).map(order => {
          let userName = order.fullName;
          if (!userName) {
            userName = `${order.firstName || ""} ${order.lastName || ""}`;
          }
          return (
                <Table.Row key={order.id}>
                    <Table.Cell>
                        {order.user.id}
                    </Table.Cell>
                    <Table.Cell>
                        {userName}
                    </Table.Cell>
                    <Table.Cell>
                        {order.email}
                    </Table.Cell>
                    <Table.Cell>
                        {formatLocalDateTime(order.purchased, 'M/DD/YY')}
                    </Table.Cell>
                    <Table.Cell className='purchase-info-modal-resend-column'>
                        {this.props.isInFlightFor === order.id ? (
                            <FieldStatusIcon show isSaving />
                        ) : this.props.resendWasSuccessfulFor === order.id ? (
                            <FieldStatusIcon show saved />
                        ) : (
                            <Button
                                primary
                                onClick={partial(this.props.resendOrderEmail, order.id)}>
                                <FormattedMessage id='rewardsStore.modal.purchaseInfo.button.resend' />
                            </Button>
                        )}
                    </Table.Cell>
                </Table.Row>
            )
        })
      }
      </Table.Body>
    );
  }
}

export default PurchaseInfoContent;



// WEBPACK FOOTER //
// ./public/pages/Rewards/RewardsTable/PurchaseInfoContent.jsx